/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CurrentProductService, ProductSummaryComponent, OutletDirective } from '@spartacus/storefront';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';
// Imported for side effects (module augmentation)
//import '../../model/augmented-core.model';

@Component({
    selector: 'udx-product-summary',
    templateUrl: './product-summary.component.html',
    styleUrls: ['./product-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [OutletDirective, AsyncPipe, TranslatePipe]
})
export class UdxB2bProductSummaryComponent extends ProductSummaryComponent {
  constructor(protected override currentProductService: CurrentProductService) {
    super(currentProductService);
  }
}
